var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Controller, } from "react-hook-form";
import { useIntl } from "react-intl";
import { Row, Col, Select } from "@folio/stripes/components";
import { PublisherRegistrationAgencyEnum } from "../../types/Api";
import { PublisherGeneral } from "./PublisherGeneral";
export var NewPublisherGeneralSection = function (_a) {
    var control = _a.control, errors = _a.errors, icoError = _a.icoError, setIcoError = _a.setIcoError, trigger = _a.trigger, setValue = _a.setValue, watch = _a.watch, icoLoadedCallback = _a.icoLoadedCallback;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "registrationAgency", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(Select, __assign({}, field, { autoComplete: "off", label: formatMessage({
                                id: "ui-br-legaldeposits.publishers.field.registrationAgency",
                            }), required: true, error: (_b = errors.registrationAgency) === null || _b === void 0 ? void 0 : _b.message, dataOptions: [
                                {
                                    value: "",
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.field.registrationAgency.default",
                                    }),
                                },
                                {
                                    value: PublisherRegistrationAgencyEnum.ISBN,
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.field.registrationAgency.ISBN",
                                    }),
                                },
                                {
                                    value: PublisherRegistrationAgencyEnum.ISMN,
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.publishers.field.registrationAgency.ISMN",
                                    }),
                                },
                            ] })));
                    } }))),
        React.createElement(PublisherGeneral, { control: control, errors: errors, icoError: icoError, setValue: setValue, watch: watch, icoLoadedCallback: icoLoadedCallback, setIcoError: setIcoError, trigger: trigger })));
};
